"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    DateUtil.getDateAsString = function (date, timezoneId) {
        if (timezoneId === void 0) { timezoneId = 'Asia/Tokyo'; }
        return moment_timezone_1.default(date).tz(timezoneId).format('YYYY-MM-DD');
    };
    DateUtil.convertUtcTimezone = function (date, timezoneId) {
        if (timezoneId === void 0) { timezoneId = 'Asia/Tokyo'; }
        return moment_timezone_1.default.utc(date).tz(timezoneId).toDate();
    };
    DateUtil.parse = function (stringOrDate) {
        var _moment = moment_timezone_1.default(stringOrDate);
        if (!isNaN(_moment))
            return _moment.toDate();
        return undefined;
    };
    DateUtil.getTimestampAsString = function (
    /**
     * Value should be millis or ISO Date String
     */
    value, timezoneId, locale) {
        var date = DateUtil.parse(value);
        if (!date)
            return '';
        var zonedDate = DateUtil.convertUtcTimezone(date, timezoneId);
    };
    DateUtil.isActive = function (startDate, endDate) {
        var start = startDate ? moment_timezone_1.default(startDate) : moment_timezone_1.default(new Date(0));
        var end = endDate ? moment_timezone_1.default(endDate) : moment_timezone_1.default(new Date(8640000000000000));
        return moment_timezone_1.default().isBetween(start, end);
    };
    DateUtil.isExpired = function (expiryDate) {
        return moment_timezone_1.default().isAfter(expiryDate);
    };
    DateUtil.currentDateUTC = function () {
        return moment_timezone_1.default().utc().format('YYYY-MM-DD HH:mm:ss');
    };
    DateUtil.currentDateTime = function () {
        return moment_timezone_1.default().format('YYYY-MM-DD HH:mm:ss');
    };
    DateUtil.expiredAt45s = function () {
        return moment_timezone_1.default().tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss');
    };
    DateUtil.format = function (date, pattern) {
        if (pattern === void 0) { pattern = 'YYYY-MM-DD HH:mm:ss'; }
        return moment_timezone_1.default(date).format(pattern);
    };
    DateUtil.formatApiDate = function (apiDateString, pattern) {
        if (pattern === void 0) { pattern = 'YYYY-MM-DD HH:mm:ss'; }
        var isValidFormat = moment_timezone_1.default(apiDateString, DateUtil.API_DATETIME_FORMAT, true).isValid();
        return isValidFormat
            ? moment_timezone_1.default(apiDateString, DateUtil.API_DATETIME_FORMAT).tz('Asia/Tokyo').format(pattern)
            : DateUtil.format(apiDateString, pattern);
    };
    DateUtil.formatUTC = function (date, timezoneId, pattern) {
        return moment_timezone_1.default
            .utc(date)
            .tz(timezoneId ? timezoneId : 'Asia/Tokyo')
            .format(pattern ? pattern : 'YYYY-MM-DD HH:mm:ss');
    };
    DateUtil.toUnixTimestamp = function (date) {
        if (date instanceof Date) {
            return (date.getTime() / 1000).toFixed(0);
        }
        return undefined;
    };
    DateUtil.API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
    return DateUtil;
}());
exports.default = DateUtil;
//# sourceMappingURL=DateUtil.js.map